import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Overview from './overview';
import ChartTable from './charttable';
import Announcement from './announcement';
import ValueGraph from './valuegraph';
import Loader from '../../components/loader';
import AssetConfig from '../../components/assetconfig';
import AssetOrder from '../../components/assetorder';
import Big from 'big.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faChartArea } from '@fortawesome/free-solid-svg-icons';
import { faListAlt } from '@fortawesome/free-regular-svg-icons';
// import PusherClient from '../../lib/pusher';

import WindowMessage from '../../components/windowmessage';

import SvgLineChart from '../../icons/svgLineChart';
import SvgPieChart from '../../icons/svgPieChart';
import SvgList from '../../icons/svgList';

import {
  fetchBalance,
  fetchMessages,
  fetchDailyPrices,
  fetchAssetValue,
  fetchFxSnapshot,
} from '../../actions';

// const assetOrder = [
//   'BTC',
//   'GOLD',
//   'SILV',
//   'ETH',
//   'PALL',
//   'PLAT',
//   'EOS',
//   'LTC',
// ];

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cachedMessages: [],
      cachedPrices: [],
      dailyPricesLoading: true,
      balanceLoading: true,
      eurEth: '',
      eurEthLoading: true,
      portfolioView: 'PIE',
    };
    this.handleAnnouncements = this.handleAnnouncements.bind(this);
    this.fetchAnnouncements = this.fetchAnnouncements.bind(this);
    this.percentChange = this.percentChange.bind(this);
    this.currencySign = this.currencySign.bind(this);
    this.toLocaleFixed = this.toLocaleFixed.bind(this);
    this.updateDailyPrices = this.updateDailyPrices.bind(this);
    this.humName = this.humName.bind(this);
    this.eurTstValue = this.eurTstValue.bind(this);
    this.changePortfolioView = this.changePortfolioView.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchBalance({ fx: true }))
      .then((res) => {
        if (res.type === 'FETCH_BALANCES_SUCCESS') {
          this.setState({ balanceLoading: false });
        }
        if (res.type === 'FETCH_BALANCES_FAIL') {
          this.setState({ balanceLoading: false });
        }
      });
    this.handleAnnouncements();
    this.updateDailyPrices();
    const assetData = {
      pair: 'ETHEUR',
    };
    dispatch(fetchAssetValue(assetData))
      .then((res) => {
        if (res.type === 'FETCH_ASSET_VALUE_SUCCESS') {
          if (res.payload.data.bid) {
            this.setState({ eurEth: res.payload.data.bid, eurEthLoading: false });
          }
        }
      });
    const dataDay = {
      period: '24hrs',
    };
    dispatch(fetchFxSnapshot(dataDay))
      .then((res) => {
        if (res.type === 'FETCH_FX_SNAPSHOT_DAY_SUCCESS') {
          this.setState({ fxSnapDayLoading: false });
        }
      });
  }

  handleAnnouncements() {
    const { dispatch } = this.props;
    const msgCache = localStorage.getItem('msgCache');
    const msgCacheTime = JSON.parse(localStorage.getItem('msgCacheTime'));
    let timeDiff;
    if (msgCacheTime) {
      timeDiff = moment().diff(msgCacheTime, 'minutes');
    }
    if (msgCache) {
      if (timeDiff > 5) {
        this.fetchAnnouncements();
      } else {
        this.setState({ cachedMessages: JSON.parse(msgCache) });
      }
    } else {
      this.fetchAnnouncements();
    }
  }

  fetchAnnouncements() {
    const { dispatch } = this.props;
    const now = moment();
    dispatch(fetchMessages())
      .then((res) => {
        if (res.type === 'FETCH_MESSAGES_SUCCESS') {
          localStorage.setItem('msgCache', JSON.stringify(res.payload));
          localStorage.setItem('msgCacheTime', JSON.stringify(now));
        }
      });
  }

  showAsset(asset) {
    let assetConf;
    if (AssetConfig && AssetConfig.length) {
      assetConf = AssetConfig.find((item) => item.handle === asset.toUpperCase());
    }
    let assetEnabled;
    if (assetConf && assetConf.enabled) {
      assetEnabled = assetConf.enabled;
    }
    return assetEnabled;
  }

  humName(asset) {
    const { assets } = this.props;
    let assetData;
    if (assets && assets.length) {
      assetData = assets.find((item) => item.handle === asset.toUpperCase());
    }
    let useName;
    if (assetData && assetData.name) {
      useName = assetData.name;
    }
    return useName;
  }

  currencySign(val) {
    if (val === 'EURCENT') {
      return '\u20AC';
    }
    if (val === 'CENT') {
      return '\u0024';
    }
  }

  toLocaleFixed(num, dec) {
    let localeFixed;
    let number = '0';
    if (num) {
      number = num;
    }
    const formatter = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: dec,
      maximumFractionDigits: dec,
    });
    if (number && dec) {
      localeFixed = formatter.format(number);
    }
    return localeFixed;
  }

  percentChange(type, newVal, oldVal) {
    const difference = oldVal - newVal;
    const change = Number(((difference / oldVal) * 100).toFixed(4));
    const isNegative = ((Math.sign(change) === Number('-1'))) || (change === 0);
    let useChange = change;
    if (change && isNegative) {
      useChange = Math.abs(change);
    }
    if (type === 'RAW') {
      return (useChange);
    }
    if (isNegative) {
      return (
        <span className="pt-pos">
          {'\u25B2 ' + useChange + '%'}
        </span>
      );
    } else {
      return (
        <span className="pt-neg">
          {'\u25BC ' + useChange + '%'}
        </span>
      );
    }
  }

  groupBy(arr, item) {
    let grouped = {};
    for (let i = 0; i < arr.length; i++) {
      var p = arr[i][item];
      if (!grouped[p]) { grouped[p] = []; }
      grouped[p].push(arr[i]);
    }
    return grouped;
  }

  updateDailyPrices() {
    const { dispatch } = this.props;
    const pricesCache = localStorage.getItem('pricesCache');
    const pricesCacheTime = JSON.parse(localStorage.getItem('pricesCacheTime'));
    const now = moment();
    if (pricesCacheTime && pricesCache) {
      if (now.isSame(pricesCacheTime, 'd')) {
        this.setState({ cachedPrices: JSON.parse(pricesCache), dailyPricesLoading: false });
      } else {
        dispatch(fetchDailyPrices())
          .then((res) => {
            if (res.type === 'FETCH_DAILY_PRICES_SUCCESS') {
              this.setState({ dailyPricesLoading: false });
              localStorage.setItem('pricesCache', JSON.stringify(res.payload));
              localStorage.setItem('pricesCacheTime', JSON.stringify(now));
            }
          });
      }
    } else {
      dispatch(fetchDailyPrices())
        .then((res) => {
          if (res.type === 'FETCH_DAILY_PRICES_SUCCESS') {
            this.setState({ dailyPricesLoading: false });
            localStorage.setItem('pricesCache', JSON.stringify(res.payload));
            localStorage.setItem('pricesCacheTime', JSON.stringify(now));
          }
        });
    }
  }

  eurTstValue(tstQuantity) {
    const { dispatch, balance, orders } = this.props;
    const ethTst = new Big(0.00001);
    let eurTst = new Big(0);
    let eurEth;
    let eurEthPrice;
    if (orders && orders.assetValue && orders.assetValue.bid) {
      eurEth = orders.assetValue.bid;
    }
    if (eurEth) {
      eurEthPrice = new Big(eurEth);
    }
    if (eurEthPrice && ethTst && tstQuantity) {
      eurTst = (eurEthPrice.times(ethTst)) * new Big(tstQuantity);
    }
    return eurTst.toFixed(8);
  }

  changePortfolioView(type) {
    this.setState({portfolioView: type});
  }

  render() {
    const { messages, user, assets } = this.props;
    const { cachedMessages, dailyPricesLoading, cachedPrices, balanceLoading, eurEthLoading, portfolioView } = this.state;

    const tradesDisabled = ((user && user.me && user.me.flags && user.me.flags.tradesDisabled) && (user.me.flags.tradesDisabled === true)) && ((user && user.me && user.me.flags && user.me.flags.verified) && (user.me.flags.verified === true));

    let userCurrencyHandle;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      userCurrencyHandle = user.me.defaults.currencyHandle;
    }

    let announcement;
    let fixedAnnouncement;
    let useMessages;
    if (cachedMessages && cachedMessages.length) {
      useMessages = cachedMessages;
    }
    if (messages && messages.length) {
      useMessages = messages;
    }
    if (useMessages) {
      announcement = useMessages.filter((item) => item.fixed === false);
      fixedAnnouncement = useMessages.filter((item) => item.fixed === true);
    }
    const uuid = Math.random().toString(36).slice(-5);

    let assetsList;
    let allowedAssets;
    if (assets && assets.length) {
      assetsList = assets && assets.map((item) => {
        let useHandle = '';
        if (item.handle) {
          useHandle = item.handle;
        }
        return (useHandle);
      });
    }
    if (assetsList && assetsList.length) {
      allowedAssets = assetsList.filter((item) => this.showAsset(item));
    }

    const renderGraph = !balanceLoading && allowedAssets;

    const tradesDisabledPost = {
      fixed: true,
      category: "Note",
      header: "Full onboarding is temporarily disabled for new customers",
      body: "Accounts created after September 6th 2021 will not be able to deposit or trade until further notice.  The team is working on updating our services to comply with new FCA regulatory obligations. Please contact support for more information."
    }

    return (
      <>
        <div className="grid-x grid-margin-x">
          {tradesDisabled ? (
            <Announcement
              postKey={'post'}
              alone={true}
              post={tradesDisabledPost}
            />
          ) : null}
        </div>
        <div className="grid-x grid-margin-x">
          {(announcement && announcement.length) ? (
            <Announcement
              postKey={'post-' + uuid}
              alone={!fixedAnnouncement.length}
              post={announcement[announcement.length - 1]}
            />
          ) : null}
          {(fixedAnnouncement && fixedAnnouncement.length) ? (
            <Announcement
              postKey={'postf-' + uuid}
              alone={!announcement.length}
              post={fixedAnnouncement[fixedAnnouncement.length - 1]}
            />
          ) : null}
        </div>
        <div className="grid-x grid-margin-x">
          <div className="cell panel small-12 medium-12 large-12">
            <div className="panel-label portfolio-select">
              <button
                className={
                  portfolioView === 'PIE' ? (
                    'port-s-btn psb-active'
                  ) : (
                    'port-s-btn'
                  )
                }
                onClick={() => this.changePortfolioView('PIE')}
              >
                <SvgPieChart />
                <span>
                  Pie Chart
                </span>
              </button>
              <button
                className={
                  portfolioView === 'GRAPH' ? (
                    'port-s-btn psb-active'
                  ) : (
                    'port-s-btn'
                  )
                }
                onClick={() => this.changePortfolioView('GRAPH')}
              >
                <SvgLineChart />
                <span>
                  Line Chart
                </span>
              </button>
              <button
                className={
                  portfolioView === 'TABLE' ? (
                    'port-s-btn psb-active'
                  ) : (
                    'port-s-btn'
                  )
                }
                onClick={() => this.changePortfolioView('TABLE')}
              >
                <SvgList />
                <span>
                  List View
                </span>
              </button>
            </div>
            {portfolioView === 'PIE' ? (
              <Overview percentChange={this.percentChange} AssetOrder={AssetOrder} showAsset={this.showAsset} humName={this.humName} currencySign={this.currencySign} toLocaleFixed={this.toLocaleFixed} userCurrencyHandle={userCurrencyHandle} updateDailyPrices={this.updateDailyPrices} eurTstValue={this.eurTstValue} eurEthLoading={eurEthLoading} />
            ) : (null)}
            {portfolioView === 'TABLE' ? (
              <ChartTable percentChange={this.percentChange} AssetOrder={AssetOrder} showAsset={this.showAsset} humName={this.humName} currencySign={this.currencySign} toLocaleFixed={this.toLocaleFixed} userCurrencyHandle={userCurrencyHandle} updateDailyPrices={this.updateDailyPrices} eurTstValue={this.eurTstValue} eurEthLoading={eurEthLoading} />
            ) : (null)}
            {portfolioView === 'GRAPH' ? (
              <>
                {renderGraph ? (
                  <ValueGraph cachedPrices={cachedPrices} percentChange={this.percentChange} AssetOrder={AssetOrder} showAsset={this.showAsset} groupBy={this.groupBy} currencySign={this.currencySign} toLocaleFixed={this.toLocaleFixed} userCurrencyHandle={userCurrencyHandle} updateDailyPrices={this.updateDailyPrices} dailyPricesLoading={dailyPricesLoading} allowedAssets={allowedAssets} />
                ) : (
                  <div className="cell panel vc-con">
                    <div className="center-loader">
                      <Loader logo />
                    </div>
                  </div>
                )}
              </>
            ) : (null)}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  balance: state.balance.balance,
  messages: state.status.messages,
  errors: state.user.errors,
  assets: state.assets.assets,
  orders: state.order,
});

export default connect(mapStateToProps)(Portfolio);
